'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${colors.secondary.lightGray1};
  /* justify-content: center; */
  padding: 10%;
  flex: 1;
  height: 100%;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  border: 3px double ${colors.semantic.negative.primary};
  border-radius: 5px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  background: ${colors.primary.white};
`;

export const Title = styled.h5`
  color: ${colors.secondary.darkGray1};
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  color: ${colors.secondary.darkGray1};
`;
